import { webLightTheme, Theme } from '@fluentui/react-components';

export const viaeroLightTheme: Theme = {
    ...webLightTheme,
    colorBrandForegroundInverted: '#0D0D0D',
    colorNeutralBackground2: 'gainsboro',
    colorBrandBackground2: '#4f4f4f',
    colorNeutralForeground2BrandHover: '#0270f5',
    colorBrandForegroundLink: '#0f4ed0',
    borderRadiusXLarge: '16px',
    colorPaletteRedBackground2: '#FDF3F4',
    colorPaletteRedForeground2: '#DC2B35',
    colorPaletteRedForeground3: '#DA1E28',
    colorPaletteGreenBackground2: '#F3F8F5',
    colorPaletteGreenForeground2: '#198038',
    colorPaletteBlueBackground2: '#F2F5FC',
    colorPaletteBlueForeground2: '#3D70DA',
    colorBrandForeground1: '#0A6FCD',
    colorBrandForeground2: '#CEE2F5',
    colorBrandStroke1: '#4793DA',
    colorNeutralStroke1: '#777',
    colorBrandBackgroundStatic: '#F2F8FF',
    colorNeutralBackground3: '#F2F2F2',
    colorNeutralBackground5: '#C2C2C2',
    colorBrandBackground: '#0A6FCD',
    fontFamilyBase: 'Rubik'
};
